module.exports = __webpack_public_path__ + "static/bus-coach-driver-jobs-a84427cb130099a8fb2e3f1e6af20236.jpg";